(ns hai.entity.data
  "Web-app events shared by every entity surface."
  (:require
   [hai.ui.rf-sugar :refer [>e defevent-fx]]))

;; Clicking a linked contact/note/task chip goes to that entity's own page. Every
;; route takes the entity map itself, the way the omnibar's search results do —
;; routed by the id attr the chip's entity carries.
;;
;; Contacts have no read view, only `:contacts/edit`, whose save and cancel both
;; navigate to the contacts table — which would strand someone who arrived from a
;; note. `:return-to` carries the current path so that page can send them back
;; where they came from instead.
(defevent-fx ::open-entity [{:keys [db]} entity]
  (let [return-to (get-in db [:routing/current-route :path])]
    {:dispatch [:routing/navigate
                (cond
                  (:contact/uuid entity) [:contacts/edit entity
                                          (cond-> {} return-to (assoc :return-to return-to))]
                  (:task/uuid entity)    [:tasks/detail entity]
                  :else                  [:notes/detail entity])]}))

(defn open-entity
  "The standard `:on-open-entity` handler — every web-app surface routes chips
   the same way; a surface without routing (the extension sidebar) omits the
   prop instead."
  [entity]
  (>e [::open-entity entity]))
